var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg61 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  transform: "translate(0 1)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FED100",
  d: "M10.696 5.998a4.7 4.7 0 0 1 4.377 2.987 9.2 9.2 0 0 0-1.845 4.81h-.533c-1.408 0-2.707.47-3.748 1.261a4.698 4.698 0 0 1 1.75-9.058"
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.498,
  height: 1.599,
  y: 9.896,
  fill: "#FED100",
  rx: 0.8
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.498,
  height: 1.599,
  x: 2.474,
  y: 15.869,
  fill: "#FED100",
  rx: 0.8,
  transform: "rotate(-45 4.723 16.669)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.498,
  height: 1.599,
  x: 14.42,
  y: 3.923,
  fill: "#FED100",
  rx: 0.8,
  transform: "rotate(-45 16.669 4.723)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.498,
  height: 1.599,
  x: 2.474,
  y: 3.923,
  fill: "#FED100",
  rx: 0.8,
  transform: "rotate(45 4.723 4.723)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.599,
  height: 4.498,
  x: 9.896,
  fill: "#FED100",
  rx: 0.8
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m29.724 11.73.096.255.415 1.174 1.23-.192q.455-.072.923-.072a5.9 5.9 0 0 1 5.897 5.898c0 3.102-2.4 5.66-5.517 5.88l2.272-3.782H29.4l2.9-6.497H22.154l-2.9 10.296h-6.56a4.698 4.698 0 0 1-.215-9.391l.215-.005h1.912l.115-1.374a7.785 7.785 0 0 1 15.002-2.19"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FED100",
  d: "M25.39 26.19h-4.998l2.9-10.296h6.697l-2.9 6.497h5.299L22.59 38.685z"
}))));
export { Svg61 as ReactComponent };